import * as React from 'react';
import sx from '@styled-system/css';
import shouldForwardProp from '@styled-system/should-forward-prop';
import variant from '@styled-system/variant';
import { ResponsiveValue } from 'styled-system';
import { styles as textVariants } from '../text';
import styled from '../styled';

export type ButtonSize = 'sm' | 'md' | 'lg';

export type ButtonProps<V> = React.HTMLAttributes<HTMLElement> & {
  disabled?: boolean;
  size?: ResponsiveValue<ButtonSize>;
  variant?: ResponsiveValue<V>;
};

const Base = styled('div', { shouldForwardProp })<ButtonProps<string>>(
  ({ disabled = false }) =>
    sx({
      display: 'flex',
      justifyContent: 'center',
      ...textVariants['-2u'],
      borderRadius: 1,
      textAlign: 'center',
      textTransform: 'uppercase',
      textDecoration: 'none',
      cursor: 'pointer',
      lineHeight: 'root',
      userSelect: 'none',
      transition:
        'color .1s linear, box-shadow .1s linear, background-color .1s linear',
      '&:[disabled]': {
        cursor: 'not-allowed',
      },
      ...(disabled && {
        cursor: 'not-allowed',
      }),
    }),
  variant({
    prop: 'size',
    variants: {
      lg: {
        fontSize: 'root',
        py: 6,
        px: 8,
      },
      md: {
        py: 4,
        px: 6,
      },
      sm: {
        py: 3,
        px: 4,
      },
    },
  }),
);

Base.defaultProps = {
  size: 'md',
  disabled: false,
};

Base.displayName = 'Monterey(Button.Base)';

export default Base;
